<template>
  <el-cascader ref="rcCascader" :value="value" v-bind="$attrs" v-on="$listeners">
    <template v-for="slot in slots" :slot="componentSlot(slot)" slot-scope="{ node, data }">
      <!-- 默认插槽 -->
      <slot v-if="isDefaultSlot(componentSlot(slot))" :name="slot" :node="node" :data="data"></slot>
      <!-- 自定义其他插槽 -->
      <slot v-else :name="slot"></slot>
    </template>
  </el-cascader>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
export default {
  name: "RcCascader",
  mixins: [slotMixins],
  props: {
    value: {
      default: ""
    },
    slots: {
      type: Array,
      default: () => (["default", "empty"])
    }
  }
};
</script>
